import { StyledStepper as Stepper } from './styled';

export default Stepper;

export enum EStepperSizes {
    small = 30,
    medium = 36,
    large = 48,
}
